import { AuthApiClient } from "../api-client/api-client";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { setUser } from "@/redux/slices/userSlice";
import { useUser as useUserQuery } from "@/features/user/hooks/use-user";

export const useUser = () => {
  const { useUserProfile } = useUserQuery();
  const { refetch } = useUserProfile({
    enabled: false,
    queryKey: ["user", "profile"]
  });
  const dispatch = useAppDispatch();
  const user = useAppSelector((state) => state.user.user);
  // Get user profile
  const refreshProfile = async () => {
    refreshStaticData();
    const response = await refetch();
    if (response?.data) dispatch(setUser(response.data));
  };
  // Get user profile
  const refreshStaticData = async () => {
    await AuthApiClient.getStaticData("fr");
  };

  return { user, refreshProfile };
};
